<template>
  <div id="account" class="container">
    <SfBreadcrumbs
        :breadcrumbs="breadcrumbs"
        class="breadcrumbs "
    />

    <div v-if="!isAuthenticated" class="notlogged">
      <SfHeading :level="1" :title="$t('Your account')"></SfHeading>
      <p>{{ $t('You are not logged, sign-in or create an account') }}</p>
      <SfButton class="color-primary" @click="toggleLoginModal">{{ $t('I log in') }}</SfButton>
    </div>
    <div v-else>
      <SfContentPages
          :active="activePage"
          :title="$t('Your account')"
          class="my-account"
          @click:change="changeActivePage"
      >

        <SfContentPage :title="$t('account.informations')">
          <div v-if="user">
            <SfImage :alt="$t('account.informations')" class="banner" height="0"
                     src="/assets/images/banner-compte.webp" width="0"></SfImage>
            <SfHeading :level="2" :title="$t('account.informations')"></SfHeading>
            <MyProfile/>
          </div>

        </SfContentPage>
        <SfContentPage :title="$t('account.address')">
          <SfHeading :level="2" :title="$t('account.address')"></SfHeading>
          <Addresses/>
        </SfContentPage>
        <SfContentPage :title="$t('account.orders')">
          <SfHeading :level="2" :title="$t('account.orders')"></SfHeading>
          <MyOrders/>
        </SfContentPage>
        <SfContentPage v-if="!showWishList" :title="$t('account.wishlist')">
          <SfHeading :level="2" :title="$t('account.wishlist')"></SfHeading>

        </SfContentPage>

        <SfContentPage :title="$t('account.logout')"/>

      </SfContentPages>
    </div>
  </div>
</template>
<script>
import {SfBreadcrumbs, SfImage, SfContentPages, SfHeading, SfButton} from '@storefront-ui/vue';

import MyProfile from './MyAccount/MyProfile';
import Addresses from './MyAccount/Addresses';
//import MyNewsletter from './MyAccount/MyNewsletter';
import MyOrders from './MyAccount/MyOrders';
import Api from "@/api/Api";


export default {
  name: 'MyAccount',

  components: {
    SfButton,
    SfImage,
    SfHeading,
    SfBreadcrumbs,
    SfContentPages,
    MyOrders,
    MyProfile,
    Addresses,
    //  OrderHistory
  },
  data() {
    return {
      pageName: null,
      showWishList: process.env.VUE_APP_WISHLIST,
      breadcrumbs: [
        {
          text: this.$t('Home'),
          link: '/'
        },
        {
          text: this.$t('Your account'),
          link: ''
        }
      ]
    };
  },
  computed: {
    activePage: {
      get() {
        const {pageName} = this.$route.params;
        if (pageName) {
          const str = this.$i18n.t(pageName.replace(/\W+/g, ' '));
          switch (pageName) {
            case 'carnet-d-adresses':
              return this.$i18n.t('account.address');
            case 'ma-liste-d-envies':
              return this.$i18n.t('account.wishlist');
            default :
              return str.charAt(0).toUpperCase() + str.slice(1);
          }
        }
        /*else {
          return this.$i18n.t("account.informations")
        }*/
      },
      set() {
      }
    },
    isAuthenticated: {
      get() {
        return this.$store.getters.isAuthenticated;
      }
    },
    user: {
      get() {
        return this.$store.getters.getProfile
      }
    },
  },
  mounted() {
    if (!this.activePage) {
      this.$router.push('/mon-compte/profil').catch();

    }
  },
  methods: {
    toggleLoginModal() {
      this.$store.dispatch('toggleLoginModal', {open:true})

    },
    changeActivePage(title) {
      if (title === this.$i18n.t('account.logout')) {
        Api.account.logout();
        this.$store.dispatch('logOutCustomer');
        this.$store.dispatch('getCategoryTree');
        this.$router.push('/').catch();


      } else {
        this.activePage = title
        this.$router.push(`/mon-compte/${(title || '').toLowerCase().replace(/\W+/g, '-')}`).catch(() => {
          return null
        })

      }
    }
  }
};
</script>

<style lang="scss" scoped>
#my-account {
  box-sizing: border-box;
  @include for-desktop {
    max-width: var(--layout-max-width);
    margin: 0 auto;
  }
}

.banner {
  margin-bottom: var(--spacer-sm);

  ::v-deep {
    img.sf-image {
      width: 100%;
      height: auto;
      border-radius: 2px;
    }

  }
}

.notlogged {
  text-align: center;

  p {
    font-size: var(--font-size--lg);
    font-weight: normal;
    margin-bottom: var(--spacer-base);
  }

  .sf-button {
    margin: auto;
  }
}

.my-account {
  @include for-mobile {
    --content-pages-sidebar-category-title-font-weight: var(--font-weight--normal);
    --content-pages-sidebar-category-title-margin: var(--spacer-sm) var(--spacer-sm) var(--spacer-sm) var(--spacer-base);
  }
  @include for-desktop {
    --content-pages-sidebar-category-title-margin: var(--spacer-xl) 0 0 0;
  }
}

.breadcrumbs {
  margin: var(--spacer-base) 0 var(--spacer-lg);
}

::v-deep {
  .sf-content-pages {
    height: auto;
  }

  .sf-menu-item {
    &__label {
      text-transform: uppercase;
      font-weight: 500;
      transition: 0.25s ease all;
      --menu-item-label-color: var(--c-primary);
      border-bottom: 1px solid transparent;
    }

    &:hover, &.is-active {
      .sf-menu-item__label {
        --menu-item-label-color: var(--_c-primary-light);
        border-bottom: 1px solid var(--_c-primary-light)
      }
    }
  }

  .sf-content-pages__content {
    padding: 0 var(--spacer-sm) var(--spacer-base) var(--spacer-sm);
    @include for-desktop {
      padding: 0 0 0 var(--spacer-base);
    }
    @include for-desktop-small {
      padding: 0 0 0 var(--spacer-base);
    }
    @include for-mobile {
      padding: 0;
    }
  }

  .sf-content-pages__content, .sf-content-pages__sidebar {
    position: relative;
    min-height: calc(-5rem + 100vh);
    height: auto;
    border-radius: 2px;
  }


  .sf-content-pages__list-item {
    --list-item-margin: var(--spacer-sm) 0;
    @include for-desktop {
      --list-item-margin: var(--spacer-sm) 0;
    }
    @include for-desktop-small {
      --list-item-margin: var(--spacer-sm) 0;
    }
  }

  .sf-content-pages__title {
    text-transform: uppercase;
    --content-pages-sidebar-title-font-size: 28px;
    font-weight: var(--font-weight--bold);
  }

  .sf-content-pages__menu {
    width: 100%;
  }

  .sf-content-pages__category-title {
    display: none;
    @include for-desktop {
      display: block;
    }
  }
}
</style>
